export default null;

export const convertPhoneNumberWithHypen = (str) => str.replace(/^(01[0|1]|[6-9]{1})([0-9]{3,4})([0-9]{4})$/, '$1-$2-$3');
export const convertCommonGender = (gender = '') => (gender && /^(M|MALE)$/g.exec(gender) ? 'MALE' : 'FEMALE');


export const convertTo24HourFormat = (time, timeType) => {
	const hour = parseInt(time, 10);
	
	if (timeType === 'P' && hour !== 12) return hour + 12;
	if (timeType === 'A' && hour === 12) return 0;
	return hour;
};

export const formatContactableTime = (contactableTime) => {
	const { startTime, startTimeType, endTime, endTimeType } = contactableTime;
	const startTime24 = convertTo24HourFormat(startTime, startTimeType);
	const endTime24 = convertTo24HourFormat(endTime, endTimeType);
	
	return `${startTime24}:00 ~ ${endTime24}:00`;
};